"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var color_1 = __importDefault(require("../color"));

var util_1 = require("../util");

util_1.injectGlobal(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tbody{\n\t\tposition:absolute;\n\t\twidth:100%;\n\t\theight:100%;\n\t\tmargin:0;\n\t\tfont-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Helvetica,Arial,sans-serif;\n\t\tfont-weight:400;\n\t\tcolor:#424242;\n\t\tfont-size:14px;\n  }\n  a {\n    text-decoration:none;\n    color:inherit;\n  }\n"], ["\n\tbody{\n\t\tposition:absolute;\n\t\twidth:100%;\n\t\theight:100%;\n\t\tmargin:0;\n\t\tfont-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Helvetica,Arial,sans-serif;\n\t\tfont-weight:400;\n\t\tcolor:#424242;\n\t\tfont-size:14px;\n  }\n  a {\n    text-decoration:none;\n    color:inherit;\n  }\n"])));
var core = {
  inline: {
    background: function background(_a) {
      var bg = _a.bg,
          bgColor = _a.bgColor,
          gradient = _a.gradient;

      if (bg) {
        if (gradient) return "linear-gradient(" + bgColor.interp(0) + ", " + bgColor.interp(gradient) + ")";else return bgColor.bg;
      } else return undefined;
    },
    color: function color(_a) {
      var color = _a.color;
      return color.fg;
    },
    fontSize: function fontSize(_a) {
      var size = _a.size;
      return util_1.round(size) + 'px';
    },
    padding: function padding(_a) {
      var padd = _a.padd,
          size = _a.size;
      return padd ? util_1.round(size / 2 * util_1.getScalar(padd)) + 'px' : undefined;
    },
    flexDirection: function flexDirection(_a) {
      var column = _a.column,
          reverse = _a.reverse;
      return (column ? 'column' : 'row') + (reverse ? '-reverse' : '');
    },
    alignItems: function alignItems(_a) {
      var align = _a.align;
      return align;
    },
    justifyContent: function justifyContent(_a) {
      var justify = _a.justify;
      return justify;
    },
    flex: function flex(_a) {
      var flex = _a.flex;
      return flex;
    },
    alignSelf: function alignSelf(_a) {
      var alignSelf = _a.alignSelf;
      return alignSelf;
    },
    overflowX: function overflowX(_a) {
      var scroll = _a.scroll,
          column = _a.column;
      return scroll && !column ? 'scroll' : undefined;
    },
    overflowY: function overflowY(_a) {
      var scroll = _a.scroll,
          column = _a.column;
      return scroll && column ? 'scroll' : undefined;
    },
    pointerEvents: function pointerEvents(_a) {
      var disabled = _a.disabled;
      return disabled ? 'none' : undefined;
    },
    opacity: function opacity(_a) {
      var disabled = _a.disabled;
      return disabled ? 0.7 : undefined;
    },
    borderRadius: function borderRadius(_a) {
      var rounded = _a.rounded,
          flatTop = _a.flatTop,
          flatLeft = _a.flatLeft,
          flatRight = _a.flatRight,
          flatBottom = _a.flatBottom,
          size = _a.size;
      var radius = util_1.round(size / 6 * util_1.getScalar(rounded));
      return rounded ? "\n\t\t\t\t" + (flatTop || flatLeft ? 0 : radius) + "px " + (flatTop || flatRight ? 0 : radius) + "px " + (flatRight || flatBottom ? 0 : radius) + "px " + (flatLeft || flatBottom ? 0 : radius) + "px\n\t\t\t" : 'none';
    },
    width: function width(_a) {
      var width = _a.width,
          size = _a.size;
      return width && (typeof width === 'string' ? width : util_1.round(width * size) + 'px');
    },
    height: function height(_a) {
      var height = _a.height,
          size = _a.size;
      return height && (typeof height === 'string' ? height : util_1.round(height * size) + 'px');
    },
    userSelect: function userSelect(_a) {
      var noselect = _a.noselect;
      return noselect ? 'none' : undefined;
    }
  },
  //prettier-ignore
  styles: util_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n    box-sizing: border-box;\n    display: flex;\n    background-clip: border-box;\n\n    border: ", ";\n\n    ", " \n    ", "\n    \n    ", "\n  "], ["\n    position: relative;\n    box-sizing: border-box;\n    display: flex;\n    background-clip: border-box;\n\n    border: ", ";\n\n    ", " \n    ", "\n    \n    ", "\n  "])), function (_a) {
    var border = _a.border,
        borderColor = _a.borderColor;
    if (border) return util_1.getScalar(border) + "px solid " + borderColor.bq;else return 'none';
  }, function (_a) {
    var size = _a.size,
        gutter = _a.gutter,
        column = _a.column,
        reverse = _a.reverse,
        lined = _a.lined;
    return gutter && "\n\t\t\t > :not(:" + (reverse ? 'last' : 'first') + "-child) {\n        " + (lined ? "padding-" + (column ? 'top' : 'left') + ":" + util_1.round(size / 4 * util_1.getScalar(gutter)) + "px;" : "margin-" + (column ? 'top' : 'left') + ":" + util_1.round(size / 4 * util_1.getScalar(gutter)) + "px;") + "\n      }\n       > :not(:" + (reverse ? 'first' : 'last') + "-child) {\n        margin-" + (column ? 'bottom' : 'right') + ":" + util_1.round(size / 4 * util_1.getScalar(gutter)) + "px;\n      }\n    ";
  }, function (_a) {
    var lined = _a.lined,
        column = _a.column,
        reverse = _a.reverse,
        borderColor = _a.borderColor;
    return lined && "\n      > :not(:" + (reverse ? 'last' : 'first') + "-child) {\n        border-" + (column ? 'top' : 'left') + ":" + util_1.getScalar(lined) + "px solid " + borderColor.bq + " !important;\n      }\n    ";
  }, function (_a) {
    var lined = _a.lined,
        endLine = _a.endLine,
        reverse = _a.reverse,
        column = _a.column,
        borderColor = _a.borderColor;
    return lined && endLine && "\n      > :" + (!reverse ? 'last' : 'first') + "-child{\n        border-" + (column ? 'bottom' : 'right') + ":" + util_1.getScalar(lined) + "px solid " + borderColor.bq + " !important;\n      }\n    ";
  }),
  props: {
    color: {
      default: new color_1.default(),
      inherit: true
    },
    borderColor: {
      extends: 'color',
      default: function _default(color) {
        return color;
      }
    },
    bgColor: {
      extends: 'color',
      default: function _default(color) {
        return color;
      }
    },
    gradient: {
      default: undefined
    },
    size: {
      default: 14,
      inherit: true
    },
    width: {
      default: undefined
    },
    height: {
      default: undefined
    },
    bg: {
      default: false
    },
    border: {
      default: undefined
    },
    padd: {
      default: undefined
    },
    column: {
      default: undefined
    },
    reverse: {
      default: undefined
    },
    justify: {
      default: 'flex-start'
    },
    flex: {
      default: 'none'
    },
    alignSelf: {
      default: undefined
    },
    align: {
      default: 'stretch'
    },
    gutter: {
      default: false
    },
    lined: {
      default: undefined
    },
    endLine: {
      default: undefined
    },
    scroll: {
      default: undefined
    },
    disabled: {
      default: undefined
    },
    rounded: {
      default: undefined
    },
    flatLeft: {
      default: undefined
    },
    flatRight: {
      default: undefined
    },
    flatTop: {
      default: undefined
    },
    flatBottom: {
      default: undefined
    },
    noselect: {
      default: undefined
    }
  }
};
exports.default = core;
var templateObject_1, templateObject_2;